/* eslint-disable perfectionist/sort-objects */
import z from 'zod';

export const JobDetailVMSchema = z.object({
	id:          z.string(),
	title:       z.string(),
	startDate:   z.date(),
	expiredDate: z.date().nullable(),
	hasApplied:  z.boolean(),
	hasSaved:    z.boolean(),
	entryUrl:    z.string().url(),
	detailUrl: 	 z.string().url(),
	detail:      z.object({
		summary:           z.string(),
		description:       z.string(),
		requirements:      z.string(),
		location:          z.string(),
		workingHours:      z.string(),
		employmentType:    z.string(),
		probation:         z.string(),
		baseSalary:        z.string(),
		salaryExample:     z.string().array(),
		salaryIncrease:    z.string().nullable(),
		salaryProgression: z.string(),
		bonusPolicy:       z.string(),
		timeOff:           z.string(),
		benefits:          z.string(),
		testimonials:      z.object({
			title:  z.string(),
			quote:  z.string(),
			role:   z.string(),
			tenure: z.string(),
		}).array(),
	}),
	company: z.object({
		id:               z.string(),
		name:             z.string(),
		description:      z.string().url().nullable(),
		mainOffice:       z.string().nullable(),
		establishment:    z.string().nullable(),
		ceo:              z.string().nullable(),
		capital:          z.number().nullable(),
		corporateWebsite: z.string().url().nullable(),
	}),

	images: z.object({
		caption: z.string().nullable(),
		url:     z.string().url().nullable(),
	}).array().max(4),

	specialInfo: z.object({
		topic:       z.string(),
		description: z.string(),
		image:       z.string().url(),
	}),

	howToApply: z.object({
		applicationSteps: z.object({
			stepNumber:  z.number(),
			description: z.string(),
		}).array(),
		applicationInstructions: z.string().nullable(),
		contactInfo:             z.string().nullable(),
	}),
});
export type JobDetailVM = z.infer<typeof JobDetailVMSchema>;
